/**
 * Copyright 2023 SweetCode. All rights reserved.
 *
 * All event listeners
 * */

// Pixel load event listener
jQuery(document).on("wpmLoadPixels", () => {

	if (wpmDataLayer?.pixels?.taboola?.account_id && !wpmDataLayer?.pixels?.taboola?.loaded) {
		if (wpm.canIFire("ads", "taboola-ads")) wpm.loadTaboolaPixel()
	}
})

// view search event
jQuery(document).on("pmwEvent:Search", () => {

	try {
		if (!wpmDataLayer?.pixels?.taboola?.loaded) return

		let data = {
			notify: "event",
			name  : "search",
			id    : wpmDataLayer.pixels.taboola.account_id,
		}

		_tfa.push(data)

	} catch (e) {
		console.error(e)
	}
})

// view order received page event
jQuery(document).on("wpmOrderReceivedPage", () => {

	try {
		if (!wpmDataLayer?.pixels?.taboola?.loaded) return

		let data = {
			notify  : "event",
			name    : "purchase",
			id      : wpmDataLayer.pixels.taboola.account_id,
			revenue : wpmDataLayer.order.value_filtered,
			currency: wpmDataLayer.order.currency,
			orderid : wpmDataLayer.order.id,
		}

		if (wpmDataLayer.order.items) {
			let itemCount = 0
			wpmDataLayer.order.items.forEach(item => {
				itemCount += parseInt(item.quantity)
			})

			data.quantity = itemCount
		}

		_tfa.push(data)

	} catch (e) {
		console.error(e)
	}
})
